<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-26 17:01:43
-->
<template>
  <div class="serviceOrder">
    <div class="top-header">
      <!-- <div class="header">企业服务订单</div> -->
      <div>
        共<b>{{ total }}</b
        >条服务订单
      </div>
    </div>
    <div class="serviceBox">
      <el-table :data="tableData" style="width: 100%" :height="4.3 + 'rem'">
        <template slot="empty">
          <img src="@/assets/images/暂无数据.png" alt="" />
          <div style="color: #00fffe;font-size: 0.14rem;">
            暂无数据
          </div>
        </template>
        <el-table-column label="" align="center" width="50">
          <template slot-scope="scope">
            <img
              src="@/assets/images/券@2x.png"
              v-if="scope.row.useCouponName"
              alt=""
              style="width: 0.2rem; vertical-align: middle"
            />
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
        <el-table-column prop="goodsName" label="产品名称"> </el-table-column>
        <el-table-column prop="firstGoodsType" label="产品类型">
        </el-table-column>
        <el-table-column prop="goodsOrg" label="机构名称"> </el-table-column>
        <el-table-column prop="createTime" label="生成时间"> </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            {{ scope.row.orderStatus | statusFilter }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { goodsOrderList } from '@api/cockpit/index'
export default {
  props: {
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      tableData: [],
      total: 0
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getGoodsOrderList()
  },
  methods: {
    getGoodsOrderList() {
      goodsOrderList({ creditCode: this.creditCode }).then(res => {
        if (res.data.code == '0000') {
          const { goodsOrderList, goodsOrderNumber } = res.data.data
          this.tableData = goodsOrderList
          this.total = goodsOrderNumber
        } else {
          this.$message.error(this.data.msg)
        }
      })
    }
  },
  filters: {
    statusFilter(val) {
      switch (val) {
        case 0:
          return '待机构确认'
        case 1:
          return '待企业确认'
        case 2:
          return '待评价'
        case 3:
          return '已评价'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.serviceOrder {
  .top-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.16rem;
    color: rgba(255, 255, 255, 100);
    .header {
      font-size: 0.16rem;
      margin-bottom: 0.16rem;
      &::before {
        content: '';
        vertical-align: middle;
        width: 0.03rem;
        height: 0.18rem;
        display: inline-block;
        margin-right: 0.1rem;
        background: #00fffe;
      }
    }
    b {
      color: #00fffe;
      margin: 5px;
    }
  }
  .serviceBox {
    margin-top: 0.1rem;
    /deep/ .el-table {
      background: transparent !important;
      .is-leaf {
        border: none;
      }
      .el-table__header {
        height: 0.48rem;
        box-sizing: border-box;
      }
      thead {
        border: 1px solid rgba(46, 178, 236, 0.5);
        box-sizing: border-box;
        th,
        tr {
          font-size: 0.14rem;
          color: rgba(0, 255, 254, 100);
          background-color: rgba(0, 103, 166, 0.25);
        }
      }
      tbody {
        tr {
          background: transparent !important;
        }
        tr:nth-child(even) {
          background: rgba(0, 103, 166, 0.25) !important;
        }
        tr:hover {
          background-color: rgba(0, 103, 166, 0.25) !important;
          box-shadow: inset 0px 0px 20px 0px rgba(0, 255, 254, 1);
        }
        tr:hover > td {
          background: transparent;
        }
        td {
          color: rgba(255, 255, 255, 0.85);
          font-size: 0.16rem;
          border: none;
        }
      }

      .el-table__body-wrapper {
        min-height: 3.6rem;
      }
    }
  }
}
</style>
